// src/utils/format.ts
// export const formatCurrency = (value: number): string => {
//     if (!value && value !== 0) return '';
//     return value.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
// };
export const formatCurrency = (
    value: number | string | null | undefined,
    currency = 'TT$'
): string => {
    if (value === null || value === undefined || value === '') return '';
    const num = typeof value === 'string' ? parseFloat(value) : value;
    if (isNaN(num)) return '';
    const formatted = num.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return `${currency}${formatted}`;
};
export const parseCurrency = (value: string): number => {
    const clean = value.replace(/,/g, '');
    return parseFloat(clean) || 0;
};

export const formatPriceDisplay = (value: number): string => {
    if (!value && value !== 0) return '';
    return value.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};
